import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { SettingsBase } from '@zero/shared/charts/ui-charts-base';
import { InstrumentChartModel } from '@zero/shared/util-models';

@Component({
  selector: 'charts-web-settings',
  templateUrl: './settings-web.component.html',
  imports: [NgbDropdownModule, TranslocoPipe],
})
export class SettingsWebComponent extends SettingsBase {
  @Input() public model: InstrumentChartModel;

  @Output() public changeType = new EventEmitter<string>();
}
